import axios, { AxiosInstance } from 'axios'
import { useApiBase } from './api-base-provider'
import { getAuthHeaders } from '../../api/auth'
import { useMemo } from 'react'

export function useApiClient(): AxiosInstance {
  const { baseUrl, isRemote, remoteToken, setRemoteLoginNeeded } = useApiBase()

  return useMemo(() => {
    const client = axios.create({
      baseURL: baseUrl || undefined,
    })

    client.interceptors.request.use((config) => {
      if (isRemote && remoteToken) {
        // Use the remote-specific token
        config.headers.Authorization = `Bearer ${remoteToken}`
      } else if (!isRemote) {
        // Use local auth
        Object.assign(config.headers, getAuthHeaders())
      }
      return config
    })

    client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (isRemote && error?.response?.status === 401) {
          setRemoteLoginNeeded(true)
        }
        return Promise.reject(error)
      }
    )

    return client
  }, [baseUrl, isRemote, remoteToken, setRemoteLoginNeeded])
}